<template>
    <div>
        
        <div class="d-flex justify-content-between">
            <div class="p-2 bd-highlight mt-auto mb-auto">
                <h3 style="color: #2F2F2F;">Kirim QR</h3>
            </div>
            <div class="p-2 bd-highlight">
                <div class="d-flex align-items-center">
                    <div class="mr-3">Saldo QR : {{numberWithCommas(saldoQr)}}</div>
                        <button
                            class="btn mpm-button-kirim-qr shadow"
                            :class="{ 'mpm-button-kirim-qr-disabled': !hasEnoughSaldo }"
                            style="height: 32px; min-width: 151px;"
                            v-b-tooltip="{
                                title: !hasEnoughSaldo ? 'Saldo QR tidak mencukupi untuk pengiriman.' : '',
                                html: true,
                                trigger: 'hover click',
                                customClass: 'kirim-qr-tooltip',
                            }"
                            @click="onBuatDeliveryClick"
                            v-if="$store.state.userData.userData.role !== 'USER SE'"
                        >
                            Kirim QR
                        </button>
                </div>
            </div>
        </div>

        <qr-issue
            class="mt-4"
            ref="qrIssue"
            @editData="handleEditData"
            @refreshSaldo="fetchData"
        />

        <edit-pengiriman-modal 
            ref="editModal"
            v-if="modal.showEditModal"
            @closeModal="modal.showEditModal = false"
            @updateTable="updateTable"
        />

        <metode-pengiriman-modal
            v-if="modal.showMetodeModal"
            :saldo-qr="saldoQr"
            @closeModal="modal.showMetodeModal = false"
            @updateTable="updateTable"
        />
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import moment from 'moment'
import qrIssue from './children/qrIssue.vue'

import EditPengirimanModal from './children/EditPengirimanModal.vue';
import MetodePengirimanModal from './children/MetodePengirimanModal.vue';

export default {
    metaInfo : {
        title : 'QR Issue'
    },
    components : {
        Multiselect,
        MetodePengirimanModal,
        EditPengirimanModal,
        qrIssue
    },
    data () {
        return {
            modal : {
                showMetodeModal : false,
                showEditModal: false
            },
            dataEdit : {
                id : '',
                package_code: '',
                kode_dealer : '',
                qty : 0,
                sender_signature : null,
            },
            saldoQr : 0
        }
    },
    computed : {
        hasEnoughSaldo () {
            return this.saldoQr > 0;
        },
    },
    mounted() {
        this.fetchData();
    },
    beforeMount () {
        document.getElementById('content').style.background = '#F8F8F8';
    },
    beforeDestroy () {
        document.getElementById('content').style.background = '';
    },
    methods : {
        onBuatDeliveryClick () {
            if (!this.hasEnoughSaldo) return;
            this.modal.showMetodeModal = true;
        },
        handleEditData (data) {
            this.modal.showEditModal = true

            this.dataEdit.id = data.id
            this.dataEdit.package_code = data.package_code || data.package || data.code || ''
            this.dataEdit.kode_dealer = data.kode_dealer
            this.dataEdit.qty = data.qty
            this.dataEdit.sender_signature = data.sender_signature
        },
        updateTable () {
            this.$refs.qrIssue.generateDatas();
            this.fetchData()
            this.modal.showMetodeModal = false;
            this.modal.showEditModal = false;
        },
        fetchData() {
            this.$http.get(`/api/qrs/highlight/dealer/saldo`)
            .then((resp)=>{
                this.saldoQr = resp.data.data.qty_after
            })
            .catch((err)=>{console.log(err)})
        },
    }
}
</script>

<style>
    .mpm-button {
        background-color :#F36F21 !important;
        color : white;
        height: 47px;
    }

    .mpm-button-outline {
        background-color :white !important;
        color : #F36F21;
        height: 47px;
    }
    
    .h-47px {
        height: 47px;
    }

    .kirim-qr-tooltip .tooltip-inner {
        background-color: #FFFFFF;
        color: #000000;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .15);
    }

    .kirim-qr-tooltip.bs-tooltip-top .arrow::before,
    .kirim-qr-tooltip.bs-tooltip-auto[x-placement^="top"] .arrow::before {
        border-top-color: #FFFFFF;
    }

    .kirim-qr-tooltip.bs-tooltip-bottom .arrow::before,
    .kirim-qr-tooltip.bs-tooltip-auto[x-placement^="bottom"] .arrow::before {
        border-bottom-color: #FFFFFF;
    }

    .kirim-qr-tooltip.bs-tooltip-left .arrow::before,
    .kirim-qr-tooltip.bs-tooltip-auto[x-placement^="left"] .arrow::before {
        border-left-color: #FFFFFF;
    }

    .kirim-qr-tooltip.bs-tooltip-right .arrow::before,
    .kirim-qr-tooltip.bs-tooltip-auto[x-placement^="right"] .arrow::before {
        border-right-color: #FFFFFF;
    }
    .mpm-button-kirim-qr {
    background-color: #F36F21 !important;
    color: #ffffff !important;
    border: 1px solid #F36F21 !important;
    }

    .mpm-button-kirim-qr.mpm-button-kirim-qr-disabled,
    .mpm-button-kirim-qr.mpm-button-kirim-qr-disabled:hover,
    .mpm-button-kirim-qr.mpm-button-kirim-qr-disabled:focus,
    .mpm-button-kirim-qr.mpm-button-kirim-qr-disabled:active {
        background-color: #CBCBCB !important;
        border-color: #CBCBCB !important;
        color: #FFFFFF !important;
        cursor: not-allowed;
    }
</style>